// extracted by mini-css-extract-plugin
export default {"artifactBodyCentered":"artifactBodyCentered--n4hHx","artifactViewerWarning":"artifactViewerWarning--STAUa","artifactViewerHeader":"artifactViewerHeader--P3IV_"};